import { sectionTypes } from '@playbooks/core/src/constants'
import { ActionCard, Assessment, ElementKind, Question } from '@playbooks/core/src/interfaces/ActionCard'

function getDataFromActionCard(card: ActionCard) {
  const data: { [key: string]: any } = {}
  card.sections.forEach(section => {
    if (section.type !== sectionTypes.CONTENT) return

    section.elements?.forEach(element => {
      if (element.kind === ElementKind.ASSESSMENT) {
        const assessment = element as Assessment

        data[assessment.id.toString()] = assessment.responses.filter(r => r.checked).map(r => r.id)
      }

      if (element.kind === ElementKind.QUESTION) {
        const question = element as Question

        data[question.id.toString()] = question.value
      }
    })
  })

  return data
}

export default getDataFromActionCard
